import LegalPage from "@/components/legal/LegalPage";

const Disclaimer = () => <LegalPage slug="disclaimer" />;

export default Disclaimer;
